import { Box, Button, Dialog, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { colors } from "../../../theme/palette";
import { Dispatch, SetStateAction } from "react";
import { useNavigate } from "react-router-dom";
import { getCreateEventTypeRoute } from "../../../routers/routeUtils";

const RulesPopUp = ({
  open,
  handleClose,
  eventType,
}: {
  open: boolean;
  handleClose: () => void;
  eventType: "training" | "friendly-match" | "tryout";
}) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "pages.events.createEvent",
  });
  const navigate = useNavigate();

  const rules = [
    {
      title: t("eventRules"),
      description: t("theseRulesAreStandardFromGoalngo"),
    },
    {
      title: t("eventScheduling"),
      description: t("eventsCannotBeScheduledLessThanSixHoursBeforeTheirStart"),
    },
    {
      title: t("eventCancellation"),
      description: t("theEventOrganizerHasTheRightToCancelTheEventBeforeItStarts"),
    },
    {
      title: t("eventInvitations"),
      description: t("theNumberOfInvitedFriendsCannotExceedTheNumberOfEventPlayers"),
    },
    {
      title: t("eventJoining"),
      description: t("participantsCanReserveTheirPlaceForFreeAndWithdrawTheirReservationAnytimeBeforeTheEventStarts"),
    },
    {
      title: t("codeOfConduct"),
      description: t("participantsAreRequiredToAdhereToTheCodeOfConductSetByTheEventOrganizer"),
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "16px",
          background: "#FFF",
          border: "1px solid #EAECF0",
          width: { xs: "80%", sm: "485px" },
        },
      }}
    >
      <Typography
        variant="body14Bold"
        sx={{
          display: "block",
          padding: "21px 0 17px",
          textAlign: "center",
          borderBottom: "1px solid #EAECF0",
        }}
      >
        {t("descriptionAndPlayingRules")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: "20px 26px ",
          borderBottom: "1px solid #EAECF0",
          rowGap: "15px",
        }}
      >
        {rules.map(({ title, description }) => (
          <Typography
            variant="body14Regular"
            sx={{
              color: colors.Dark600,
            }}
          >
            <Typography
              variant="body16ExtraBold"
              sx={{
                color: colors.Green100,
              }}
            >
              {title}{" "}
            </Typography>
            {description}
          </Typography>
        ))}
      </Box>
      <Button
        fullWidth
        variant="primary-md"
        onClick={() => {
          handleClose();
          navigate(getCreateEventTypeRoute(eventType));
        }}
        autoFocus
        sx={{
          margin: "14px auto",
          maxWidth: "440px",
        }}
      >
        {t("agree")}
      </Button>
    </Dialog>
  );
};

export default RulesPopUp;
